import { RoleCode } from '../models/user/user.enums';

/**
 * Utility class for managing role colors across the application
 */
export class RoleColorsUtil {
	private static readonly roleColors: Record<RoleCode, string> = {
		[RoleCode.SUPER_ADMIN]: '#dc2626',
		[RoleCode.ADMIN]: '#f97316',
		[RoleCode.SUPERVISOR]: '#10b981',
		[RoleCode.LEAD_HAND]: '#f59e0b',
		[RoleCode.APPROVER]: '#06b6d4',
		[RoleCode.WAREHOUSE_PERSONNEL]: '#8b5cf6',
		[RoleCode.WEBHOOK_USER]: '#6b7280',
		[RoleCode.CC_VIEWER]: '#eab308'
	};

	/**
	 * Gets the color for a specific role
	 * @param role - The role code
	 * @returns The hex color string for the role
	 */
	public static getRoleColor(role: RoleCode): string {
		return this.roleColors[role] || '#6b7280';
	}

	/**
	 * Gets all role colors mapping
	 * @returns Record of all role colors
	 */
	public static getAllRoleColors(): Record<RoleCode, string> {
		return { ...this.roleColors };
	}
}
